import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IVenue} from "../../models/Venue";

interface VenuesState {
    venues: IVenue[],
    venuesLoading: boolean
}
const initialState: VenuesState = {
    venues: [],
    venuesLoading: true
}

export const venuesSlice = createSlice({
    name: "venues",
    initialState,
    reducers: {
        setVenues: (state, action: PayloadAction<IVenue[]>) => {
            state.venues = action.payload;
            state.venuesLoading = false;
        }
    }

})

export const {setVenues} = venuesSlice.actions;

export default venuesSlice.reducer;